<template>
    <div>
        <div class="container checkout-container pt-lg-4">
            <div class="checkout-container-row-1 mb-4 mb-md-4 mb-lg-5">
                <h1 class="h2-like-text">
                    {{ $root.translateString("complete_order") }}
                </h1>
                <p class="text-grey text-smaller-mobile mt-3" v-html="$root.translateString('gift-message-p')" v-if="should_be_shipped"></p>
                <p class="text-grey text-smaller-mobile mt-3" v-html="$root.translateString('gift-message-p-no-shipping')" v-else></p>
            </div>

            <div class="row mx-0">
                <div class="col-lg-7 col-xl-8">
                    <div class="checkout-container-row-2__title checkout-title mt-0" v-if="!isLogged">
                        <h4 class="checkout-title__left">01.</h4>
                        <h6 class="checkout-title__right text-uppercase">{{ $root.translateString("personal_details") }}</h6>
                    </div>
                    <div class="checkout-container-row-2__inputs" v-if="!isLogged">
                        <div class="cart-dati-1-inputs">
                            <div class="small-banner d-flex align-items-center p-3 mb-3">
                                <a class="cover" href="javascript:void(0)" @click="summonPopup"></a>
                                <img alt="login" class="mr-1" src="/images/area-utente/user-gold.svg" width="25" />
                                <p class="ml-1 pl-2 torna-prodotti-link text-lightgrey text-smaller-85 mb-0 d-inline-flex flex-grow-1">
                                    {{ $root.translateString("have-an-account") }}
                                    <span class="ml-2 text-gold" href="javascript:void(0)" @click="toggleLogin">
                                        <span>{{ $root.translateString("login-now") }}</span>
                                    </span>
                                </p>
                                <span class="arrow mr-1"><img width="32" src="/images/svg/roeno-17.svg" alt="dettagli" /></span>
                            </div>

                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row pt-3">
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.new_user.name.state = null" v-model="new_user.name" />
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.new_user.name.state == false }">{{ validation.new_user.name.message }}</div>
                                    <label class="full-input__after-input">
                                        {{ $root.translateString("name") }}
                                    </label>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <div class="full-input__field-gr">
                                        <input placeholder=" " type="text" @focus="validation.new_user.email.state = null" v-model="new_user.email" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.new_user.email.state == false }">{{ validation.new_user.email.message }}</div>
                                        <label class="full-input__after-input"> Email </label>
                                    </div>
                                </div>
                            </div>

                            <div class="checkout-container-row-2__checkbox mt-4 pt-3">
                                <div class="checkbox-styles">
                                    <div class="checkbox">
                                        <input type="checkbox" id="accept_privacy" @change="validation.new_user.privacy.state = null" v-model="new_user.privacy" />
                                        <label class="d-inline-block w-100" for="accept_privacy"></label>
                                    </div>
                                    <label for="accept_privacy" class="checkbox-styles__link mb-0">
                                        {{ $root.translateString("acceptance") }} &nbsp;<a :href="'/' + lang + '/privacy-policy'">{{ $root.translateString("acceptance_link") }}</a>
                                        <div class="invalid-feedback pt-1" :class="{ 'd-block': validation.new_user.privacy.state == false }">{{ validation.new_user.privacy.message }}</div>
                                    </label>
                                </div>
                                <div class="checkbox-styles mt-3">
                                    <div class="checkbox">
                                        <input id="create_account" type="checkbox" v-model="new_user.create_account" />
                                        <label class="d-inline-block w-100" for="create_account"></label>
                                    </div>
                                    <label for="create_account" class="checkbox-styles__link mb-0">
                                        {{ $root.translateString("create-new-account") }}
                                    </label>
                                </div>
                            </div>

                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row mt-4 pt-2" v-if="new_user.create_account">
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="password" @focus="validation.new_user.password.state = null" v-model="new_user.password" />
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.new_user.password.state == false }">{{ validation.new_user.password.message }}</div>
                                    <label class="full-input__after-input">
                                        {{ $root.translateString("password") }}
                                    </label>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <div class="full-input__field-gr">
                                        <input placeholder=" " type="password" @focus="validation.new_user.password_confirmation.state = null" v-model="new_user.password_confirmation" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.new_user.password_confirmation.state == false }">{{ validation.new_user.password_confirmation.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("password_confirmation") }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="checkout-container-row-2__title checkout-title" :class="{ 'pt-0 mt-2': isLogged, 'pt-4': !isLogged }">
                        <h4 class="checkout-title__left">
                            <span v-if="!isLogged">02.</span>
                            <span v-else>01.</span>
                        </h4>
                        <h6 class="checkout-title__right text-uppercase">{{ $root.translateString("shipping_details") }}</h6>
                    </div>
                    <div v-if="should_be_shipped">
                        <div class="checkout-container-row-2__inputs">
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row mt-5 mb-5" v-if="isLogged && user.addresses.length >= 1 && user.addresses[0].new === false">
                                <div class="double-input-select__field-gr w-100 double-input-select__field-gr--less-space-between">
                                    <div class="w-100">
                                        <div class="w-100 cursor-pointer">
                                            <div class="select-arrow">
                                                <img alt="icona" src="/images/svg/roeno-06.svg" width="9" />
                                            </div>
                                            <v-select
                                                @input="manageSaveAddressCheckbox"
                                                :clearable="false"
                                                v-model="address"
                                                label="label"
                                                :class="{ full: user.addresses != null && user.addresses != '' }"
                                                :options="user.addresses"
                                                index="value">
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        {{ $root.translateString("no_results") }} <strong>{{ search }}</strong>
                                                    </template>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="flex">
                                                        <div class="w-100">
                                                            {{ option.label }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    {{ option.label }}
                                                </template>
                                            </v-select>
                                            <label class="placeholder">
                                                {{ $root.translateString("select-an-address") }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="full-input">
                                <div class="full-input__field-gr">
                                    <input placeholder=" " type="text" @focus="validation.address.name.state = null" v-model="address.name" />
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.address.name.state == false }">{{ validation.address.name.message }}</div>
                                    <label class="full-input__after-input">
                                        {{ $root.translateString("name") }}
                                    </label>
                                </div>
                            </div>
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.address.phone.state = null" v-model="address.phone" />
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.address.phone.state == false }">{{ validation.address.phone.message }}</div>
                                    <label class="full-input__after-input">
                                        {{ $root.translateString("phone") }}
                                    </label>
                                </div>
                                <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                    <v-select
                                        @input="validation.address.country.state = null"
                                        v-model="address.country"
                                        :class="{ full: address.country != null && address.country != '' }"
                                        :options="countries"
                                        label="value"
                                        index="label"
                                        :reduce="(label) => label.label">
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                <small class="not-found"
                                                    >{{ $root.translateString("no_results") }} <strong>{{ search }}</strong></small
                                                >
                                            </template>
                                        </template>
                                    </v-select>
                                    <label class="placeholder">
                                        {{ $root.translateString("country") }}
                                    </label>
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.address.country.state == false }">{{ validation.address.country.message }}</div>
                                </div>
                            </div>
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.address.address.state = null" v-model="address.address" />
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.address.address.state == false }">{{ validation.address.address.message }}</div>
                                    <label class="full-input__after-input">
                                        {{ $root.translateString("address") }}
                                    </label>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <div class="full-input__field-gr">
                                        <input placeholder=" " type="text" @focus="validation.address.city.state = null" v-model="address.city" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.address.city.state == false }">{{ validation.address.city.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("city") }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="double-input double-input--checkout d-flex flex-column flex-sm-row flex-md-column flex-lg-row">
                                <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between" v-if="address.country.toLowerCase() == 'it' || address.country.toLowerCase() == ''">
                                    <v-select
                                        @input="validation.address.province.state = null"
                                        v-model="address.province"
                                        :class="{ full: address.province != null && address.province != '' }"
                                        :options="provinces"
                                        label="value"
                                        index="label"
                                        :reduce="(label) => label.label">
                                        <template v-slot:no-options="{ search, searching }">
                                            <template v-if="searching">
                                                <small class="not-found"
                                                    >{{ $root.translateString("no_results") }} <strong>{{ search }}</strong></small
                                                >
                                            </template>
                                        </template>
                                    </v-select>
                                    <label class="placeholder">
                                        {{ $root.translateString("province") }}
                                    </label>
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.address.province.state == false }">{{ validation.address.province.message }}</div>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between" v-else>
                                    <input placeholder=" " type="text" v-model="address.province" />
                                    <label class="double-input-select__after-input no-pointers">
                                        {{ $root.translateString("province") }}
                                    </label>
                                </div>
                                <div class="double-input__field-gr double-input__field-gr--less-space-between">
                                    <input placeholder=" " type="text" @focus="validation.address.cap.state = null" v-model="address.cap" />
                                    <div class="invalid-feedback" :class="{ 'd-block': validation.address.cap.state == false }">{{ validation.address.cap.message }}</div>
                                    <label class="double-input-select__after-input no-pointers">
                                        {{ $root.translateString("cap") }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-grey mb-3">
                            {{ $root.translateString("shipped-via-email") }}
                        </p>
                        <div class="checkout-container-row-2__checkbox mt-3" v-if="address.country.toLowerCase() == 'it'">
                            <div class="checkbox-styles">
                                <div class="checkbox">
                                    <input type="checkbox" id="invoice" v-model="user.billing.require_invoice" />
                                    <label class="d-inline-block w-100" for="invoice"></label>
                                </div>
                                <label for="invoice" class="checkbox-styles__link mb-0">
                                    {{ $root.translateString("ask_for_invoice") }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="checkout-container-row-2__checkbox mt-3" v-if="(!hide_save_address || new_user.create_account) && should_be_shipped">
                        <div class="checkbox-styles">
                            <div class="checkbox">
                                <input type="checkbox" id="save_new_address" v-model="save_new_address" />
                                <label class="d-inline-block w-100" for="save_new_address"></label>
                            </div>
                            <label for="save_new_address" class="checkbox-styles__link mb-0">
                                {{ $root.translateString("save-new-address") }}
                            </label>
                        </div>
                    </div>

                    <!-- billing -->

                    <div class="checkout-container-row-2 pt-2" v-if="address.country.toLowerCase() == 'it'">
                        <div class="w-100" v-if="user.billing.require_invoice">
                            <div class="checkout-container-row-2__title checkout-title">
                                <h4 class="checkout-title__left" v-if="!isLogged">03.</h4>
                                <h4 class="checkout-title__left" v-else>02.</h4>
                                <h6 class="checkout-title__right text-uppercase">{{ $root.translateString("invoice_details") }}</h6>
                            </div>

                            <!-- <div class="checkout-container-row-3__all-payments mb-4">
                            <div class="checkout-container-row-3__payment d-flex">
                                <div class="radio">
                                    <input id="radio-invoice1" name="radio-invoice" type="radio" value="private" v-model="billing.type">
                                    <label for="radio-invoice1" class="radio-label">
                                        <span>{{$root.translateString('private')}}</span>
                                    </label>
                                </div>
                                <div class="radio ml-5">
                                    <input id="radio-invoice2" name="radio-invoice" type="radio" value="company" v-model="billing.type">
                                    <label for="radio-invoice2" class="radio-label">
                                        <span>{{$root.translateString('company')}}</span>
                                    </label>
                                </div>
                            </div>
                        </div> -->

                            <div class="checkout-container-row-2__inputs">
                                <div class="double-input-select" v-if="billing.type == 'company'">
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="text" v-model="billing.name" @focus="validation.billing.name.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.name.state == false }">{{ validation.billing.name.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("company_name") }}
                                        </label>
                                    </div>
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="text" v-model="billing.fiscal_code" @focus="validation.billing.fiscal_code.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.fiscal_code.state == false }">{{ validation.billing.fiscal_code.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("vat") }}
                                        </label>
                                    </div>
                                </div>

                                <div class="double-input-select" v-if="billing.type == 'company'">
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="email" v-model="billing.pec" @focus="validation.billing.pec.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.pec.state == false }">{{ validation.billing.pec.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("pec") }}
                                        </label>
                                    </div>
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="text" v-model="billing.sdi" @focus="validation.billing.sdi.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.sdi.state == false }">{{ validation.billing.sdi.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("sdi") }}
                                        </label>
                                    </div>
                                </div>

                                <div class="double-input-select" v-if="billing.type == 'company'">
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="email" v-model="billing.address" @focus="validation.billing.address.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.address.state == false }">{{ validation.billing.address.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("address") }}
                                        </label>
                                    </div>
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="text" v-model="billing.city" @focus="validation.billing.city.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.city.state == false }">{{ validation.billing.city.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("city") }}
                                        </label>
                                    </div>
                                </div>

                                <div class="double-input-select" v-if="billing.type == 'company'">
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <v-select
                                            @input="validation.billing.province.state = null"
                                            v-model="billing.province"
                                            :class="{ full: billing.province != null && billing.province != '' }"
                                            :options="provinces"
                                            label="value"
                                            index="label"
                                            :reduce="(label) => label.label">
                                            <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    <small class="not-found"
                                                        >{{ $root.translateString("no_results") }} <strong>{{ search }}</strong></small
                                                    >
                                                </template>
                                            </template>
                                        </v-select>
                                        <label class="placeholder">
                                            {{ $root.translateString("province") }}
                                        </label>
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.address.province.state == false }">{{ validation.address.province.message }}</div>
                                    </div>
                                    <div class="double-input-select__field-gr double-input-select__field-gr--less-space-between">
                                        <input placeholder=" " type="number" v-model="billing.cap" @focus="validation.billing.cap.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.cap.state == false }">{{ validation.billing.cap.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("cap") }}
                                        </label>
                                    </div>
                                </div>

                                <div class="full-input" v-if="billing.type != 'company'">
                                    <div class="full-input__field-gr">
                                        <input placeholder=" " type="text" v-model="billing.fiscal_code" @focus="validation.billing.fiscal_code.state = null" />
                                        <div class="invalid-feedback" :class="{ 'd-block': validation.billing.fiscal_code.state == false }">{{ validation.billing.fiscal_code.message }}</div>
                                        <label class="full-input__after-input">
                                            {{ $root.translateString("fiscal_code") }}
                                        </label>
                                    </div>
                                </div>

                                <div class="checkout-container-row-2__checkbox mt-2 mt-lg-5" v-if="!hide_save_billing_info || new_user.create_account">
                                    <div class="checkbox-styles">
                                        <div class="checkbox">
                                            <input type="checkbox" id="save_billing_info" class="cb" name="save_billing_info" v-model="save_billing_info" />
                                            <label for="save_billing_info"></label>
                                        </div>
                                        <label for="save_billing_info" class="checkbox-styles__link checkout mb-0">
                                            <span>{{ $root.translateString("update-billing-data") }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- payment methods -->

                    <div class="checkout-container-row-3">
                        <div class="w-100">
                            <div class="checkout-container-row-3__title checkout-title mt-5">
                                <h4 class="checkout-title__left" v-if="!isLogged"><span v-text="user.billing.require_invoice == false ? '03. ' : '04. '"></span></h4>
                                <h4 class="checkout-title__left" v-else><span v-text="user.billing.require_invoice == false ? '02. ' : '03. '"></span></h4>
                                <h6 class="checkout-title__right text-uppercase">
                                    <span class="d-767-none">{{ $root.translateString("payment_methods") }}</span>
                                    <span class="d-768-none">{{ $root.translateString("payment_methods_short") }}</span>
                                </h6>
                            </div>

                            <div class="checkout-container-row-3__all-payments">
                                <div class="checkout-container-row-3__payment d-flex" v-if="address.country.toLowerCase() == 'it'">
                                    <div class="radio flex-grow-1">
                                        <input id="radio-1" name="radio" type="radio" value="stripe" v-model="pay.method" />
                                        <label for="radio-1" class="radio-label"
                                            ><span>{{ $root.translateString("credit_card") }}</span>
                                        </label>
                                        <div class="checkout-container-row-3__info">
                                            {{ $root.translateString("credit_card_p") }}
                                        </div>
                                    </div>
                                    <div>
                                        <img src="/images/svg/credit-card.svg" alt="Carta di credito" height="25" />
                                    </div>
                                </div>

                                <div class="checkout-container-row-3__payment d-flex" v-if="address.country.toLowerCase() == 'it'">
                                    <div class="radio flex-grow-1">
                                        <input id="radio-2" name="radio" type="radio" value="bank" v-model="pay.method" />
                                        <label for="radio-2" class="radio-label"
                                            ><span>{{ $root.translateString("wire_transfer") }}</span></label
                                        >
                                        <div class="checkout-container-row-3__info">
                                            {{ $root.translateString("wire_transfer_p") }}
                                        </div>
                                    </div>
                                    <div>
                                        <img src="/images/svg/bankwire.svg" alt="Bonifico bancario" height="25" />
                                    </div>
                                </div>
                                <div class="checkout-container-row-3__payment d-flex" v-else>
                                    <div class="radio flex-grow-1">
                                        <input id="radio-6" name="radio" type="radio" value="bank" v-model="pay.method" />
                                        <label for="radio-6" class="radio-label"
                                            ><span>{{ $root.translateString("estimation") }}</span></label
                                        >
                                        <div class="checkout-container-row-3__info d-flex">
                                            {{ $root.translateString("estimation_p") }}
                                        </div>
                                    </div>
                                    <div></div>
                                </div>
                                <!-- <div class="checkout-container-row-3__payment">
                                <div class="radio">
                                    <input id="radio-3" name="radio" type="radio" value="cash_on_delivery" v-model="pay.method">
                                    <label for="radio-3" class="radio-label">
                                        <span>{{$root.translateString('cash_on_delivery')}}</span>
                                    </label>
                                    <div class="checkout-container-row-3__info">
                                        {{$root.translateString('cash_on_delivery_p')}}
                                    </div>
                                </div>
                            </div> -->
                                <div class="checkout-container-row-3__payment d-flex" v-if="address.country.toLowerCase() == 'it'">
                                    <div class="radio flex-grow-1">
                                        <input id="radio-4" name="radio" type="radio" value="paypal" v-model="pay.method" />
                                        <label for="radio-4" class="radio-label">
                                            <span>Paypal</span>
                                        </label>
                                        <div class="checkout-container-row-3__info">
                                            {{ $root.translateString("paypal_p") }}
                                        </div>
                                    </div>
                                    <div>
                                        <img src="/images/svg/paypal.svg" alt="Paypal" height="25" />
                                    </div>
                                </div>
                                <!-- <div class="checkout-container-row-3__payment d-flex" v-if="paymentRequest != null && address.country.toLowerCase() == 'it'">
                                <div class="radio flex-grow-1">
                                    <input id="radio-5" name="radio" type="radio" value="applePay" v-model="pay.method">
                                    <label for="radio-5" class="radio-label">
                                        <span>Apple Pay / Google Pay</span>
                                    </label>
                                    <div class="checkout-container-row-3__info">
                                        {{$root.translateString('apple_pay_p')}}
                                    </div>
                                </div>
                                <div>
                                    <img src="/images/svg/apple-google-pay.svg" alt="Apple Pay - Google Pay" height="25"/>
                                </div>
                            </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="checkout-container-row-3" v-if="address.country.toLowerCase() == 'it' && should_be_shipped">
                        <div class="w-100">
                            <div class="checkout-container-row-3__title checkout-title mt-5">
                                <h4 class="checkout-title__left" v-if="!isLogged"><span v-text="user.billing.require_invoice == false ? '04. ' : '05. '"></span></h4>
                                <h4 class="checkout-title__left" v-else><span v-text="user.billing.require_invoice == false ? '03. ' : '04. '"></span></h4>
                                <h6 class="checkout-title__right text-uppercase">
                                    <span>{{ $root.translateString("ask_for_gift") }}</span>
                                </h6>
                            </div>
                            <!--<div class="checkout-container-row-3__checkbox mt-2 mt-lg-5">
                            <div class="checkbox-styles">
                                <div class="checkbox">
                                    <input type="checkbox" id="giftPack">
                                    <label class="d-inline-block w-100" for="giftPack" @click="giftPack.status = !giftPack.status"></label>
                                </div>
                                <div class="checkbox-styles__link checkbox-link-js" @click="giftPack.status = !giftPack.status">
                                    {{$root.translateString('ask_for_gift')}}
                                </div>
                            </div>
                        </div>-->
                            <div class="full-textarea full-textarea__field-gr" v-if="giftPack.status">
                                <div class="full-textarea__field-gr d-flex w-100 flex-column mt-5">
                                    <textarea name="message" id="" rows="3" placeholder="Messaggio" v-model="giftPack.message" required></textarea>
                                    <label class="full-textarea__after-textarea">
                                        {{ $root.translateString("giftpack_title") }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="checkout-container-row-4 px-0">
                        <div class="checkout-container-row-4__protected protected-key pt-2 mt-4 mb-0">
                            <img src="/images/svg/roeno-02.svg" alt="icona" />
                            <span v-text="lang == 'it' ? 'Verrai reindirizzato ad una pagina sicura per completare il pagamento' : 'You will be redirected to a safe page to complete the payment'"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-xl-4 side-panel mt-5 mt-lg-0">
                    <div class="checkout-left d-767-none">
                        <div class="checkout-left__title">
                            {{ $root.translateString("summary") }}
                        </div>
                        <div class="checkout-left__all-items">
                            <div class="checkout-left__item" v-for="(item, key) in cart" :key="key">
                                <div class="checkout-left__item-1">{{ item.qty }} x</div>
                                <div class="checkout-left__item-2">
                                    <div class="checkout-left__item-2-title" v-html="item.options.name"></div>
                                    <div class="checkout-left__item-2-subtitle">
                                        <span v-if="item.options.type == 'visite' || item.options.type == 'eventi'">
                                            <span class="mr-0">{{ parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids) }}</span>
                                            <span class="text-grey" v-if="item.options.visit.adults == 1">{{ $root.translateString("person") }}</span>
                                            <span class="text-grey" v-else>{{ $root.translateString("people") }}</span>
                                            <span v-if="item.options.combination && item.options.type != 'eventi'">
                                                -
                                                {{ translateVisitOptional(item.options.combination.replace(" ", "")) }}
                                            </span>
                                        </span>
                                        <span v-else-if="item.options.type == 'gift-card'">
                                            <span v-if="lang == 'it'" class="text-grey">
                                                Valore: <span class="text-grey">{{ $root.currencyDisplaySimple(item.options.price) }}€</span>
                                            </span>
                                            <span class="text-grey" v-else>
                                                <span class="text-grey">{{ $root.currencyDisplaySimple(item.options.price) }}€</span> Value
                                            </span>
                                        </span>
                                        <span v-else>{{ item.options.combination }}</span>
                                    </div>
                                </div>
                                <div class="checkout-left__item-3">
                                    <div class="price-style">
                                        <span>€</span><span>{{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="checkout-left__subtotal">
                            <div class="checkout-left__subtotal-left">{{ $root.translateString("subtotal") }}</div>
                            <div class="checkout-left__subtotal-right">€ {{ $root.currencyDisplaySimple(priceTotalWt) }}</div>
                        </div>
                        <div class="w-100" v-if="should_be_shipped">
                            <div class="checkout-left__subtotal" v-if="address.country.toLowerCase() == 'it'">
                                <div class="checkout-left__subtotal-left">{{ $root.translateString("shipping") }}</div>
                                <div class="checkout-left__subtotal-right">
                                    <span v-if="shipping > 0"> € {{ $root.currencyDisplaySimple(shipping) }} </span>
                                    <span v-else>{{ $root.translateString("free") }}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column" v-else>
                                <div class="checkout-left__subtotal">
                                    <div class="checkout-left__subtotal-left">{{ $root.translateString("shipping") }}</div>
                                    <div class="checkout-left__subtotal-right">
                                        <span>
                                            {{ $root.translateString("tbd") }}
                                        </span>
                                    </div>
                                </div>
                                <div class="checkout-left__subtotal">
                                    <div class="checkout-left__subtotal-left">{{ $root.translateString("customs") }}</div>
                                    <div class="checkout-left__subtotal-right">
                                        <span>
                                            {{ $root.translateString("tbd") }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="checkout-left__subtotal" v-if="discount > 0">
                            <div class="checkout-left__subtotal-left">{{ $root.translateString("discount") }}</div>
                            <div class="checkout-left__subtotal-right">€ -{{ $root.currencyDisplaySimple(discount) }}</div>
                        </div>

                        <div class="checkout-left__separator"></div>
                        <div class="checkout-left__total" v-if="address.country.toLowerCase() == 'it'">
                            <div class="checkout-left__total-left">
                                <div class="t1">{{ $root.translateString("total") }}</div>
                                <div class="t2">{{ $root.translateString("tax_included") }}</div>
                            </div>
                            <div class="checkout-left__total-right">
                                <div class="price-style">€{{ $root.currencyDisplaySimple(finalPrice) }}</div>
                            </div>
                        </div>
                        <div class="checkout-left__total" v-else>
                            <div class="checkout-left__total-left">
                                <div class="t1">
                                    {{ $root.translateString("estimation_explanation") }}
                                </div>
                            </div>
                        </div>
                        <discount-box :lang="lang" :discount="discount"></discount-box>
                    </div>
                </div>
                <div class="col-12">
                    <div class="checkout-container-row-5 mt-0 mt-md-5 pt-3">
                        <div class="brand-btn">
                            <!-- v-if="pay.method != 'applePay'" @click="createOrder" -->
                            <button type="button" @click="createOrder" class="full px-lg-5" href="javascript:void(0)" :class="{ loading: loading }" :disabled="btn_disabled">
                                <span>{{ $root.translateString("complete_order") }}</span>
                            </button>
                            <!-- <a class="full px-lg-5" v-else @click="paymentRequest.show();createOrder()" href="javascript:void(0)" :class="{'loading' : loading}" :disabled="btn_disabled">
                            <span>{{$root.translateString('complete_order')}}</span>
                        </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["lang", "provinces", "countries", "isLogged", "userProp"],
        data() {
            return {
                user: {
                    addresses: [],
                    billing: {
                        require_invoice: false,
                        data: {
                            type: "company",
                            name: "",
                            fiscal_code: "",
                            sdi: "",
                            pec: "",
                            address: "",
                            city: "",
                            cap: "",
                            province: "",
                            country: "IT",
                        },
                    },
                },
                hide_save_billing_info: true,
                save_billing_info: false,
                save_new_address: false,
                hide_save_address: true,
                new_user: {
                    name: "",
                    email: "",
                    password: "",
                    confirm_password: "",
                    create_account: false,
                },
                hasGift: false,
                stripeObject: null,
                paymentRequest: null,
                loading: false,
                pay: {
                    method: "stripe",
                },
                discount_placeholder: true,
                giftPack: {
                    status: true,
                    message: "",
                },
                address: {
                    name: "",
                    address: "",
                    city: "",
                    cap: "",
                    province: "",
                    country: "IT",
                },
                billing: {
                    type: "company", //normally is private, here we forced company
                    name: "",
                    fiscal_code: "",
                    sdi: "",
                    pec: "",
                    address: "",
                    city: "",
                    cap: "",
                    province: "",
                    country: "IT",
                },
                discountCode: "",
                cartRaw: null,
                priceTotalWt: 0,
                finalPrice: 0,
                shipping: 0,
                discount: 0,
                count: 0,
                showDiscountBox: false,
                missing_for_free_shipping: 0,
                validation: {
                    new_user: {
                        name: {
                            state: null,
                            message: "",
                        },
                        email: {
                            state: null,
                            message: "",
                        },
                        phone: {
                            state: null,
                            message: "",
                        },
                        password: {
                            state: null,
                            message: "",
                        },
                        password_confirmation: {
                            state: null,
                            message: "",
                        },
                        privacy: {
                            state: null,
                            message: "",
                        },
                    },
                    address: {
                        name: {
                            state: null,
                            message: "",
                        },
                        phone: {
                            state: null,
                            message: "",
                        },
                        address: {
                            state: null,
                            message: "",
                        },
                        /*email: {
                        state: null,
                        message: '',
                    },*/
                        city: {
                            state: null,
                            message: "",
                        },
                        cap: {
                            state: null,
                            message: "",
                        },
                        province: {
                            state: null,
                            message: "",
                        },
                        country: {
                            state: null,
                            message: "",
                        },
                        /*privacy: {
                        state: null,
                        message: '',
                    },*/
                    },
                    billing: {
                        name: {
                            state: null,
                            message: "",
                        },
                        fiscal_code: {
                            state: null,
                            message: "",
                        },
                        sdi: {
                            state: null,
                            message: "",
                        },
                        pec: {
                            state: null,
                            message: "",
                        },
                        address: {
                            state: null,
                            message: "",
                        },
                        city: {
                            state: null,
                            message: "",
                        },
                        cap: {
                            state: null,
                            message: "",
                        },
                        province: {
                            state: null,
                            message: "",
                        },
                        country: {
                            state: null,
                            message: "",
                        },
                    },
                    discount: {
                        state: null,
                        message: "",
                    },
                },
                btn_disabled: false,
                profile_loaded: false,
                billing_memo: null,
                should_be_shipped: false,
            };
        },
        created() {
            if (typeof this.userProp != "undefined" && this.isLogged) {
                if (typeof this.userProp.billing !== "undefined" && this.userProp.billing != null) {
                    this.$set(this.user, "billing", this.userProp.billing);
                }

                this.$set(this.user, "addresses", this.userProp.addresses);

                let new_address = {
                    new: true,
                    label: "Usa nuovo indirizzo",
                    name: "",
                    address: "",
                    city: "",
                    cap: "",
                    province: "",
                    country: "IT",
                };

                for (let i = 0; i < this.user.addresses.length; i++) {
                    this.$set(this.user.addresses[i], "new", false);
                    this.$set(this.user.addresses[i], "label", this.user.addresses[i].address + " - " + this.user.addresses[i].cap + " - " + this.user.addresses[i].city + " (" + this.user.addresses[i].province + ")");
                }

                if (this.user.addresses.length == 0) {
                    this.hide_save_address = false;
                }

                this.user.addresses.push(new_address);

                this.address = this.user.addresses[0];
                this.billing = this.user.billing.data;

                this.billing_memo = JSON.parse(JSON.stringify(this.billing));
            }

            if (this.isLogged && this.userProp.billing == null) {
                this.hide_save_billing_info = false;
            }

            this.getCart();
        },
        watch: {
            billing: {
                handler: function (n, o) {
                    if (this.profile_loaded && this.isLogged && this.userProp.billing != null) {
                        if (JSON.stringify(n) != JSON.stringify(this.billing_memo)) {
                            this.hide_save_billing_info = false;
                        } else {
                            this.hide_save_billing_info = true;
                        }
                    }
                },
                deep: true,
            },
            "user.billing.require_invoice": {
                handler: function (n, o) {
                    if (!n && this.isLogged) {
                        this.billing = this.billing_memo;
                    }
                },
                deep: true,
            },
            "address.country": {
                handler: function (n, o) {
                    if (n != "IT") {
                        this.pay.method = "bank";
                        this.address.province = "";
                        this.user.billing.require_invoice = false;
                    } else {
                        this.pay.stripe = "stripe";
                    }
                },
            },
        },
        mounted() {
            if ($(".side-panel").length) {
                var top = $(".side-panel").offset().top;
                var width = 0;
                var left = $(".side-panel").offset().left;
                var bounds = document.querySelector(".side-panel").getBoundingClientRect();

                $(window).on("resize", function () {
                    window.scrollTo(0, 0);
                    $(".side-panel").removeClass("position-fixed");
                    $(".side-panel").css("top", "");
                    $(".side-panel").css("width", "");
                    $(".side-panel").css("left", "");

                    top = $(".side-panel").offset().top;
                    width = 0;
                    left = $(".side-panel").offset().left;
                    bounds = document.querySelector(".side-panel").getBoundingClientRect();
                });

                function setSideMenu() {
                    if ($(window).width() <= 991) {
                        return false;
                    }

                    if ($(window).scrollTop() < top - 48) {
                        $(".side-panel").removeClass("position-fixed");
                        $(".side-panel").css("top", "");
                        $(".side-panel").css("width", "");
                        $(".side-panel").css("left", "");
                    } else {
                        $(".side-panel").addClass("position-fixed");

                        var ch = $(".side-panel").height();

                        var fp = $(".checkout-container-row-4").get(0).getBoundingClientRect().top;

                        if (fp < ch + 20) {
                            var ofst = -(ch - fp);

                            $(".side-panel").css("top", ofst);
                        } else {
                            $(".side-panel").css("top", 20);
                        }

                        $(".side-panel").css("width", width);
                        $(".side-panel").css("left", left);
                    }
                }

                setTimeout(() => {
                    if ($(".side-panel").length && $(window).width() >= 992) {
                        top = $(".side-panel").offset().top;
                        width = $(".side-panel").outerWidth();

                        if ($(".side-panel").length) {
                            setSideMenu();
                        }

                        $(window).on("scroll", function () {
                            if ($(".side-panel").length) {
                                setSideMenu();
                            }
                        });

                        $(window).on("resize", function () {
                            window.scrollTo(0, 0);
                            $(".side-panel").removeClass("position-fixed");
                            $(".side-panel").css("top", "");
                            $(".side-panel").css("width", "");
                            $(".side-panel").css("left", "");

                            if ($(window).width() >= 991) {
                                top = $(".side-panel").offset().top;
                                width = $(".side-panel").outerWidth();

                                if ($(".side-panel").length) {
                                    setSideMenu();
                                }
                            } else {
                                $(".side-panel").removeClass("position-fixed");
                                $(".side-panel").css("top", "");
                                $(".side-panel").css("width", "");
                                $(".side-panel").css("left", "");
                            }
                        });
                    }
                }, 500);

                this.$eventHub.$on("discount.applied", (payload) => {
                    this.getCart();
                });
            }
        },
        methods: {
            translateVisitOptional(str) {
                if (this.lang == "en" && str.indexOf("tagliere") > -1) {
                    if (str.indexOf("pax") > -1) {
                        return str.split(" - ")[0] + " - cold cuts included";
                    } else {
                        return str.split(" - ")[0] + " - without cold cuts";
                    }
                }
                return str;
            },
            summonPopup() {
                this.$eventHub.$emit("login", { hide_register: true });
            },
            manageSaveAddressCheckbox() {
                if (this.address.new) {
                    this.hide_save_address = false;
                } else {
                    this.hide_save_address = true;
                    this.save_new_address = false;
                }
            },
            toggleLogin() {
                this.$eventHub.$emit("login", {});
            },
            loadStripe() {
                axios.get("/api/cart/stripe").then((response) => {
                    this.stripeObject = Stripe(response.data.pkey);

                    var paymentRequest = this.stripeObject.paymentRequest({
                        country: "IT",
                        currency: "eur",
                        total: {
                            label: "Ordine Shop Cantina Roeno",
                            amount: parseInt(parseFloat(this.finalPrice) * 100),
                        },
                        requestPayerName: true,
                        requestPayerEmail: true,
                    });

                    // Check the availability of the Payment Request API first.
                    paymentRequest.canMakePayment().then((result) => {
                        if (result) {
                            this.paymentRequest = paymentRequest;
                        } else {
                            this.paymentRequest = null;
                        }
                    });
                });
            },
            getCart() {
                axios.get("/api/cart/get").then((response) => {
                    this.cartRaw = response.data.cart;
                    this.count = response.data.count;
                    this.priceTotalWt = response.data.priceTotalWt;
                    this.finalPrice = response.data.finalPrice;
                    this.shipping = response.data.shipping;
                    this.discount = response.data.discount;
                    this.missing_for_free_shipping = response.data.missingForFreeShipping;
                    this.should_be_shipped = response.data.shouldBeShipped;
                    this.hasGift = response.data.hasGift;
                    this.loadStripe();

                    if (!this.should_be_shipped) {
                        this.hide_save_address = true;
                    }

                    if (this.cart.length == 0) {
                        window.location.href = "/carrello";
                    } else {
                        let products_gtm = [];

                        Object.keys(this.cart).forEach((key) => {
                            let entry = {};

                            if (typeof this.cart[key].options.gaId != "undefined") {
                                entry.item_id = this.cart[key].options.gaId;
                            } else {
                                entry.item_id = this.cart[key].id;
                            }

                            entry.quantity = this.cart[key].qty;
                            entry.item_brand = "Cantina Roeno";
                            entry.item_name = this.cart[key].options.name.replace("<br>", " ");
                            entry.price = this.$root.currencyDisplayGtm(this.cart[key].price);
                            entry.item_variant = this.cart[key].options.combination.toLowerCase();
                            entry.item_category = this.cart[key].options.type;
                            products_gtm.push(entry);
                        });

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "begin_checkout",
                            ecommerce: {
                                items: products_gtm,
                            },
                        });

                        //

                        let temp_cart = [];
                        let temp_cart_ids = [];

                        Object.keys(this.cart).forEach((key) => {
                            let entry = {};

                            if (typeof this.cart[key].options.gaId != "undefined") {
                                entry.id = this.cart[key].options.gaId;
                            } else {
                                entry.id = this.cart[key].id;
                            }

                            entry.quantity = this.cart[key].qty;
                            temp_cart.push(entry);
                            temp_cart_ids.push(entry.id);
                        });

                        fbq("track", "InitiateCheckout", {
                            content_category: "checkout",
                            content_ids: temp_cart_ids,
                            contents: temp_cart,
                            currency: "EUR",
                            num_items: this.cart.length,
                            value: this.finalPrice,
                        });

                        this.profile_loaded = true;
                    }
                });
            },
            createOrder() {
                this.btn_disabled = true;
                if (this.canProceed()) {
                    this.loading = true;

                    if (this.giftPack.message == "") {
                        this.giftPack.status = false;
                    }

                    axios
                        .post("/api/cart/create-order", {
                            lang: this.lang,
                            pay: this.pay.method,
                            address: this.address,
                            save_new_address: this.save_new_address,
                            save_billing_info: this.save_billing_info,
                            new_user: this.new_user,
                            require_invoice: this.user.billing.require_invoice,
                            billing: this.billing,
                            discountCode: this.discountCode,
                            giftPack: this.giftPack,
                        })
                        .then((response) => {
                            console.log(response);
                            if (response.data.action == "stripe_js") {
                                //var stripe = Stripe(response.data.pkey);
                                this.stripeObject
                                    .redirectToCheckout({
                                        sessionId: response.data.payment_intent,
                                    })
                                    .then(function (result) {
                                        result.error.message;
                                        this.btn_disabled = false;
                                    });
                            } else if (response.data.action == "stripe_apple_pay") {
                                var stripe = this.stripeObject;
                                var clientSecret = response.data.client_secret;
                                var confirm_page = response.data.confirm_page;
                                this.paymentRequest.on("paymentmethod", (ev) => {
                                    stripe.confirmCardPayment(clientSecret, { payment_method: ev.paymentMethod.id }, { handleActions: false }).then(function (confirmResult) {
                                        //console.log(confirmResult);
                                        if (confirmResult.error) {
                                            ev.complete("fail");
                                        } else {
                                            ev.complete("success");
                                            stripe.confirmCardPayment(response.data.client_secret).then(function (result) {
                                                if (result.error) {
                                                    // The payment failed -- ask your customer for a new payment method.
                                                } else {
                                                    window.location.href = confirm_page;
                                                }
                                            });
                                        }
                                    });
                                });
                            } else if (response.data.action == "redirect") {
                                window.location.href = response.data.next_action;
                            }
                        })
                        .catch((e) => {
                            if (typeof e.response.data.location != "undefined") {
                                window.location.href = e.response.data.location;
                            } else {
                                window.location.reload(true);
                            }
                        });
                }
            },
            isNotEmpty(object) {
                return _.isEmpty(object) === false;
            },
            canProceed() {
                let is_invalid = false;

                /* */

                if (!this.isLogged) {
                    Object.keys(this.validation.new_user).forEach((elem, key) => {
                        this.validation.new_user[elem].message = "";
                        this.validation.new_user[elem].state = null;
                    });

                    if (this.new_user.name == "") {
                        if (this.lang == "it") {
                            this.validation.new_user.name.message = "Questo campo non può essere vuoto.";
                        } else {
                            this.validation.new_user.name.message = "This field cannot be empty.";
                        }
                        this.validation.new_user.name.state = false;
                        is_invalid = true;
                    } else {
                        this.validation.new_user.name.state = null;
                    }

                    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    let disposable = require("is-disposable-email");
                    if (!re.test(this.new_user.email)) {
                        if (this.lang == "it") {
                            this.validation.new_user.email.message = "Non sembra un indirizzo email valido.";
                        } else {
                            this.validation.new_user.email.message = "The email address is invalid.";
                        }
                        this.validation.new_user.email.state = false;
                        is_invalid = true;
                    } else {
                        if (disposable(this.new_user.email)) {
                            if (this.lang == "it") {
                                this.validation.new_user.email.message = "Tipologia di servizio email non valido.";
                            } else {
                                this.validation.new_user.email.message = "You email provider is invalid.";
                            }
                            this.validation.new_user.email.state = false;
                            is_invalid = true;
                        } else {
                            this.validation.new_user.email.state = null;
                        }
                    }

                    if (this.new_user.create_account) {
                        if (this.new_user.password == "") {
                            if (this.lang == "it") {
                                this.validation.new_user.password.message = "Questo campo non può essere vuoto.";
                            } else {
                                this.validation.new_user.password.message = "This field cannot be empty.";
                            }
                            this.validation.new_user.password.state = false;
                            is_invalid = true;
                        } else {
                            this.validation.new_user.password.state = null;
                        }

                        if (this.new_user.password_confirmation != this.new_user.password || this.user.password_confirmation == "") {
                            if (this.lang == "it") {
                                this.validation.new_user.password_confirmation.message = "Questo campo deve coincidere con la password.";
                            } else {
                                this.validation.new_user.password_confirmation.message = "Questo campo non può essere vuoto.";
                            }
                            this.validation.new_user.password_confirmation.state = false;
                            is_invalid = true;
                        } else {
                            this.validation.new_user.password_confirmation.state = null;
                        }
                    }

                    if (!this.new_user.privacy) {
                        if (this.lang == "it") {
                            this.validation.new_user.privacy.message = "È necessario accettare i termini.";
                        } else {
                            this.validation.new_user.privacy.message = "You need to accept the terms.";
                        }
                        this.validation.new_user.privacy.state = false;
                        is_invalid = true;
                    }
                }

                /* */

                Object.keys(this.validation.address).forEach((elem, key) => {
                    this.validation.address[elem].message = "";
                    this.validation.address[elem].state = null;
                });

                Object.keys(this.validation.billing).forEach((elem, key) => {
                    this.validation.billing[elem].message = "";
                    this.validation.billing[elem].state = null;
                });

                if (this.should_be_shipped) {
                    $.each(this.address, (key, elem) => {
                        if (typeof this.validation.address[key] != "undefined") {
                            if (elem == "") {
                                if (key == "province" && this.address.country.toLowerCase() != "it") {
                                    //do nothing
                                } else {
                                    if (this.lang == "it") {
                                        this.validation.address[key].message = "Il campo è obbligatorio";
                                    } else {
                                        this.validation.address[key].message = "This field is required";
                                    }

                                    this.validation.address[key].state = false;
                                    is_invalid = true;
                                }
                            }
                        }
                    });
                }

                if (this.user.billing.require_invoice) {
                    if (this.billing.type == "company") {
                        $.each(this.billing, (key, elem) => {
                            if (elem == "" && key != "sdi" && key != "pec") {
                                if (this.lang == "it") {
                                    this.validation.billing[key].message = "Il campo è obbligatorio";
                                } else {
                                    this.validation.billing[key].message = "This field is required";
                                }
                                this.validation.billing[key].state = false;
                                is_invalid = true;
                            }
                        });

                        if (this.billing.sdi == "" && this.billing.pec == "") {
                            if (this.lang == "it") {
                                this.validation.billing.pec.message = "Compila PEC o Codice univoco";
                                this.validation.billing.sdi.message = "Compila PEC o Codice univoco";
                            } else {
                                this.validation.billing.pec.message = "Either one between PEC or SDI is required";
                                this.validation.billing.sdi.message = "Either one between PEC or SDI is required";
                            }
                            this.validation.billing.pec.state = false;
                            this.validation.billing.sdi.state = false;

                            is_invalid = true;
                        }
                    } else {
                        if (this.billing.fiscal_code == "") {
                            if (this.lang == "it") {
                                this.validation.billing.fiscal_code.message = "Il campo è obbligatorio";
                            } else {
                                this.validation.billing.fiscal_code.message = "This field is required";
                            }
                            this.validation.billing.fiscal_code.state = false;
                            is_invalid = true;
                        }
                    }
                }

                if (is_invalid) {
                    setTimeout(() => {
                        this.btn_disabled = false;

                        let elements = document.querySelectorAll(".invalid-feedback");

                        window.scroll({
                            top: parseInt(elements[0].getBoundingClientRect().top + window.scrollY) - 150,
                            behavior: "smooth",
                        });
                    }, 500);

                    return false;
                }

                /* */

                let temp_cart_ids = [];

                Object.keys(this.cart).forEach((key) => {
                    if (typeof this.cart[key].options.gaId != "undefined") {
                        temp_cart_ids.push(this.cart[key].options.gaId);
                    } else {
                        temp_cart_ids.push(this.cart[key].id);
                    }
                });

                fbq("track", "AddPaymentInfo", {
                    content_category: "checkout",
                    content_ids: temp_cart_ids,
                    currency: "EUR",
                    value: this.finalPrice,
                });

                /* */

                return true;
            },
        },
        computed: {
            cart() {
                if (this.cartRaw == null) {
                    return null;
                }

                let tmp = {};
                for (const [key, value] of Object.entries(this.cartRaw)) {
                    if (typeof value.options.isDiscount == "undefined" || value.options.isDiscount == false) {
                        tmp[key] = value;
                    }
                }

                return tmp;
            },
            managePaymentMethodsCardinal() {
                if (!this.isLogged) {
                    return this.user.billing.require_invoice == false ? "03. " : "04. ";
                } else {
                    return this.user.billing.require_invoice == false ? "02. " : "03. ";
                }
            },
        },
    };
</script>

<style lang="scss">
    .v-select {
        .vs__dropdown-toggle {
            padding: 0 !important;
            background: none !important;
            border: 0 !important;
        }

        .vs__selected-options {
            padding: 0px !important;
        }

        .vs__actions {
            display: none !important;
        }

        .vs__dropdown-menu {
            top: 41px !important;
            border: 0;
            box-shadow: none;
            background: #f1ece5;

            &::-webkit-scrollbar {
                width: 4px; /* For Chrome, Safari, and Opera */
            }
        }

        .vs__search,
        .vs__search:focus {
            background: transparent;
            border: 0;
            border-bottom: 1px solid #c9c8c0;
            outline: none !important;
            color: #b4b3aa;
            padding: 7px 2px;
            font-size: 1rem;
            width: 100%;
            font-family: "europa", sans-serif;
            margin: 4px;
            margin-left: 0px;
            margin-right: 0px;
        }

        .not-found {
            color: #776c5d !important;
            font-size: 0.9rem !important;
        }

        .vs__dropdown-option {
            padding: 6px 20px;
            color: #a09688;
            background: none;

            &:hover {
                color: #776c5d;
            }
        }

        & ~ label.placeholder {
            position: absolute;
            left: 0rem;
            width: 100%;
            font-size: 1rem;
            color: #b4b3aa;
            position: absolute;
            width: 100%;
            top: 0;
            left: 0;
            margin: 0;
            padding: 7px 2px;
            transition: all 0.1s;
            z-index: 10;
            text-align: left;
            pointer-events: none;
        }

        &.vs--open,
        &.full {
            & ~ label.placeholder {
                transform: translate(0px, -22px);
                font-size: 73%;
            }
        }

        .vs__selected {
            margin: 0;
            padding: 0 0.15em;
            position: absolute;
            left: 0;
            top: 9px;
            color: #b4b3aa;
        }
    }
</style>
